import { render, staticRenderFns } from "./VideoLessons.vue?vue&type=template&id=2926f2f3&scoped=true&"
import script from "./VideoLessons.vue?vue&type=script&lang=ts&"
export * from "./VideoLessons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926f2f3",
  null
  
)

export default component.exports